import {
  DEFAULT_QUERY_OPTIONS,
  getPollingOptions,
  useGetList,
} from "#hooks/adapters/adapterUtils";
import { ExceptionUtils } from "#src/utils/exception";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "@validereinc/common-components";
import { JobAdapter, JobStatus, Resources } from "@validereinc/domain";
import { BaseError, downloadLink } from "@validereinc/utilities";

export const JOBS_KEY = Resources.JOB;

export const useGetOneJob = (id: string) =>
  useQuery({
    queryKey: ["job", "getOne", id],
    queryFn: async () => JobAdapter.getOne({ id }),
    enabled: Boolean(id),
    ...getPollingOptions([JobStatus.FAILED, JobStatus.FINISHED]),
    ...DEFAULT_QUERY_OPTIONS,
  });

export const useListJobs = useGetList(JobAdapter.getList, JOBS_KEY);

export const useExportJobItems = (
  params: Parameters<typeof JobAdapter.jobItem.exportList>[0]
) => {
  return useMutation({
    mutationFn: async () => {
      const report = await JobAdapter.jobItem.exportList?.(params);
      if (!report?.s3_download_link) {
        throw new BaseError(
          `Could not fetch download URL for job items export`,
          { cause: report }
        );
      }
      downloadLink(report.s3_download_link, report.name);
    },
    onError: (error) => {
      ExceptionUtils.reportException(error, "error");
      toast.push({
        intent: "error",
        description: "Failed to export job items.",
      });
    },
  });
};
